namespace $ { $mol_style_attach( "giper/balls/game/game.view.css",
 "@keyframes giper_balls_game_score_show {\n\tfrom {\n\t\ttransform: scale(200%);\n\t}\n}\n\n[giper_balls_game] {\n\t-webkit-touch-callout: none\n}\n\n[giper_balls_game_score] {\n\tanimation: giper_balls_game_score_show .25s ease-out;\n}\n"
) }